import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_HEADER_CLASS,
  TItemHeaderProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemHeader: FC<TItemHeaderProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="ItemHeader"
    className={cn(ITEM_HEADER_CLASS, className)}
  >
    { children }
  </div>
);

ItemHeader.displayName = "ItemHeader";
